import { ApiProperty } from '@nestjs/swagger';

export class ApiResponseDto<T> {
  @ApiProperty(
    {
      type: 'boolean',
      description: 'Indicates if the request was successful',
      example: true,
    }
  )
  success: boolean;

  @ApiProperty(
    {
      type: 'number',
      description: 'The HTTP status code',
      example: 200,
    }
  )
  statusCode: number;

  @ApiProperty(
    {
      type: 'string',
      description: 'A message describing the result of the request',
      example: 'Newsfeeds retrieved successfully',
    }
  )
  message: string;

  @ApiProperty(
    {
      type: 'number',
      description: 'The page number of the paginated response',
      example: 1,
    }
  )
  page?: number | null;

  @ApiProperty(
    {
      type: 'number',
      description: 'The limit of items per page of the paginated response',
      example: 10,
    }
  )
  limit?: number | null;

  @ApiProperty(
    {
      type: 'number',
      description: 'The total number of records in the response',
      example: 10,
    }
  )
  totalRecords?: number | null;

  @ApiProperty(
    {
      type: 'number',
      description: 'The total number of pages in the response',
      example: 1,
    }
  )
  totalPages?: number | null;

  @ApiProperty()
  data?: T;
}
